export * from './documentdetailversion.component';
